const version = "2.60.0-candrelease";

export default version;
